<template>
  <div class="workspace_wrap">
    <p class="noticeTopLine">
      <el-button type="primary" @click="addlist(0)" size="small">添加公告</el-button>
    </p>
    <el-table
            :data="tableData"
            border
            style="width: 100%">
      <el-table-column
              header-align="center"
              align="center"
              prop="content"
              label="内容"
      >
      </el-table-column>
      <el-table-column
              header-align="center"
              align="center"
              prop="create_time"
              label="时间"
      >
      </el-table-column>
      <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200">
        <template slot-scope="scope">
          <div class="btn_line_span">
            <span @click="addlist(1,scope.$index)">查看</span>
            <span @click="detel(scope.$index)">删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag_wrap">
      <el-pagination
              background
              :page-size="page.pagesize"
              :current-page="page.pageindex"
              layout="total, prev, pager, next"
              :total="page.total"
              @current-change="pageIndexChange"></el-pagination>
    </div>
    <addgoodsNotice :visible.sync="noticevisible" :dialogType="dialogType"
                    :dialogContent="dialogContent" @loadInitFn="loadInitFn"></addgoodsNotice>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {pagination} from "@/util/util.js";
  import addgoodsNotice from "@/components/dialog/addgoodsNotice.vue";

  export default {
    name: "cardTags",
    components: {
      addgoodsNotice
    },
    data() {
      return {
        tableData: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        dialogType: 0,
        dialogContent: '',
        noticevisible: false
      };
    },
    created() {
      // 所属栏目
      let loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
    },
    methods: {
      InitFn(loading) {
        this.axios
            .post(api.shopconf_notice, {})
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list
                this.page.total = response.data.all_page
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      addlist(option, index) {
        this.dialogType = option
        if (option === 1) {
          this.dialogContent = this.tableData[index]
        }
        this.noticevisible = true
      },
      detel(index){
        let self_ = this
        this.$confirm('删除后将不能恢复，是否删除该公告?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          // 所属栏目
          let loading = self_.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
          });
          self_.axios
              .post(api.shopconf_notice_delete, {id:self_.tableData[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  self_.InitFn(loading);
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });
      },
      loadInitFn(){
        let loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.InitFn(loading)
      },
      pageIndexChange(){
        
      }
    }
  };
</script>
